<template>
  <div style="color: #666;width: 70%;margin: 0 auto">
    <div style="margin: 20px 0; ">
      <el-button type="info" @click="$router.go(-1)" size="small" style="margin-left: 0px">返回</el-button>

      <div style="text-align: center"> <h1>{{item.name}}</h1></div>

      <div style="font-size: 14px;margin-top: 5px">
        <span>{{ item.time }}</span>
      </div>
    </div>

    <div style="margin: 20px 0">
      <mavon-editor
          class="md"
          :value="item.content"
          :subfield="false"
          :defaultOpen="'preview'"
          :toolbarsFlag="false"
          :editable="false"
          :scrollStyle="true"
          :ishljs="true"
      />
    </div>

  </div>
</template>

<script>

export default {
  name: "",
  data() {
    return {
      item: {},
      user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {},
      id: this.$route.query.id,
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      this.request.get("/article/" + this.id).then(res => {
        this.item = res.data
      })
    },
  }
}
</script>

<style scoped>

</style>
